/*
  Sprawdzamy czy użytkownik ma ustawione cookie sekcji w której się znajduje. Cookie o nazwie 'section-type' przyjmuje wartość "he" lub "she".
    Jeśli użytkownik jest w sekcji "she" to link loga ustawiamy zgodny z wartością zmiennej sheUrl.



 */
import {getSectionCookie} from "./section-cookie";

export default function homeUrl() {
    const logoContainer = document.querySelector('.logo-container');
    if(logoContainer) {
        const logoLink = logoContainer.querySelector('.logo-container__link');
        const heUrl = logoContainer.dataset.he_home;
        const sheUrl = logoContainer.dataset.she_home;
        const sectionCookie = getSectionCookie();
        if (sectionCookie === 'she') {
            logoLink.setAttribute('href', sheUrl);
        } else {
            logoLink.setAttribute('href', heUrl);
        }
    }
}